import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

const TransactionCard = ({ transaction, onTransactionClick, type }) => {
  const { user } = useAuth();

  return (
    <div 
      className="bg-white rounded-lg shadow-md p-4"
      onClick={() => onTransactionClick(transaction.id)}
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-900">{transaction.contact_name}</p>
          <p className="text-sm text-gray-500">{formatDate(transaction.transaction_date, { user })}</p>
        </div>
        <div className="text-right">
          <p className="text-sm font-medium text-gray-900">
            {type === 'sales' ? `$${parseFloat(transaction.sale_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : `$${parseFloat(transaction.purchase_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          </p>
          <p className="text-sm text-gray-500">{transaction.coins_description}</p>
        </div>
      </div>
    </div>
  );
};

export default TransactionCard;
